module.exports = __webpack_public_path__ + "img/ctrl-pauli-y-root-dagger-stub--.b5fa700a.svg";